import * as React from 'react';
import {Route, Switch, withRouter} from 'react-router-dom';
// @ts-expect-error
import type {ContextRouter} from 'react-router-dom';
// @ts-expect-error
import YouTube from 'react-youtube';

import classnames from 'classnames';

// @ts-expect-error - imported from .js/.jsx file
import {CloseIcon} from 'shells/icon/svg/close-icon';
import {MainContentContainer} from 'shells/layout/main-content-container';
import {ModalLightbox} from 'shells/modal/modal-lightbox';

import {analyticsClient} from '../../../analytics-client';
import {setBodyId, clearBodyClasses} from '../../../dom';

import {PageTitleBar} from '../../layout';
import {EmailFeatureGate} from '../../limits/feature-gates/email-feature-gate';

import {EmailHeaderButtons} from '../email-header-buttons';
import {hasEmailSequenceCapability} from '../has-email-sequence-capability';

import {FailedMail} from './failed-mail/failed-mail';
import {Inbox} from './inbox/inbox';
import {ScheduledMail} from './scheduled-mail/scheduled-mail';
import {SentMail} from './sent-mail/sent-mail';

import styles from './mailbox-root.module.css';

const VIDEO_ID = 'PGDFvG7jais';

function getTitles(page: string): {
    pageTitle: string;
    pageSubTitle: string;
} {
    if (page.includes('inbox')) {
        return {
            pageTitle: 'Inbox',
            pageSubTitle: 'Your email inbox, inside Nutshell',
        };
    } else if (page.includes('sent')) {
        return {
            pageTitle: 'Sent',
            pageSubTitle: 'Email that has been sent',
        };
    } else if (page.includes('scheduled')) {
        return {
            pageTitle: 'Scheduled',
            pageSubTitle: 'All your outgoing emails',
        };
    } else if (page.includes('failed')) {
        return {
            pageTitle: 'Failed',
            pageSubTitle: 'Emails that failed while trying to be sent',
        };
    } else {
        return {
            pageTitle: 'Email',
            pageSubTitle: 'All your messages in one place',
        };
    }
}

type State = {
    isVideoModalOpen: boolean;
};

export class MailboxRoot extends React.PureComponent<Record<any, any>, State> {
    constructor() {
        // @ts-expect-error
        super();
        this.state = {
            isVideoModalOpen: false,
        };
    }

    render() {
        return (
            <React.Fragment>
                <PageTitleBarContainerRouted />
                <MainContentContainer includesHeader={false}>
                    <div className={classnames('flex flex-dir-col', styles['email-page-main'])}>
                        <Switch>
                            <Route
                                path='/email/inbox'
                                render={() => {
                                    clearBodyClasses();
                                    setBodyId('email');

                                    analyticsClient.track(
                                        analyticsClient.EVENTS.TRACK_EMAIL_INBOX_PAGE_VIEWED
                                    );

                                    return <Inbox />;
                                }}
                            />
                            <Route
                                path='/email/sent'
                                render={() => {
                                    clearBodyClasses();
                                    setBodyId('email');

                                    analyticsClient.track(
                                        analyticsClient.EVENTS.TRACK_EMAIL_SENT_PAGE_VIEWED
                                    );

                                    return <SentMail />;
                                }}
                            />
                            <Route
                                path='/email/scheduled/:scheduledMessageId?'
                                render={() => {
                                    clearBodyClasses();
                                    setBodyId('email');

                                    analyticsClient.track(
                                        analyticsClient.EVENTS.TRACK_EMAIL_SCHEDULED_PAGE_VIEWED
                                    );

                                    const hasScheduledEmailsCapability =
                                        hasEmailSequenceCapability();
                                    if (!hasScheduledEmailsCapability) {
                                        return <EmailFeatureGate />;
                                    }

                                    return <ScheduledMail onOpenVideoModal={this.openVideoModal} />;
                                }}
                            />
                            <Route
                                path='/email/failed'
                                render={() => {
                                    clearBodyClasses();
                                    setBodyId('email');

                                    analyticsClient.track(
                                        analyticsClient.EVENTS.TRACK_EMAIL_FAILED_PAGE_VIEWED
                                    );

                                    return <FailedMail />;
                                }}
                            />
                        </Switch>
                    </div>
                    {this.state.isVideoModalOpen ? (
                        <ModalLightbox onClose={this.closeVideoModal}>
                            <div
                                onClick={this.closeVideoModal}
                                className={styles['modal-container']}
                            >
                                <button onClick={this.closeVideoModal} data-tip='Close'>
                                    <CloseIcon size={17} />
                                </button>
                                <YouTube
                                    videoId={VIDEO_ID}
                                    opts={{
                                        height: '414',
                                        width: '736',
                                        playerVars: {
                                            autoplay: 1,
                                            list: 'PLoLQikdPun7d2d3fahIfUni9854Zm1DxS',
                                            listType: 'playlist',
                                            modestbranding: 1,
                                            rel: 0,
                                        },
                                    }}
                                />
                            </div>
                        </ModalLightbox>
                    ) : undefined}
                </MainContentContainer>
            </React.Fragment>
        );
    }

    openVideoModal = () => {
        this.setState({isVideoModalOpen: true});
        analyticsClient.track(analyticsClient.EVENTS.TRACK_VIDEO_POPUP_VIEWED, {
            videoId: VIDEO_ID,
        });
    };

    closeVideoModal = () => {
        this.setState({isVideoModalOpen: false});
    };
}

class PageTitleBarContainer extends React.PureComponent<ContextRouter> {
    render() {
        const {pageTitle, pageSubTitle} = getTitles(this.props.location.pathname);

        return (
            <PageTitleBar
                title={pageTitle}
                subheaderPrimaryText={pageSubTitle}
                buttons={<EmailHeaderButtons />}
            />
        );
    }
}

const PageTitleBarContainerRouted = withRouter(PageTitleBarContainer);
